import React from 'react'
// libs
import styled from 'styled-components'
// hooks
import { useMediaQuery } from '@mui/material'
// components
import Drawer, { DrawerProps } from '@mui/material/Drawer'
// constants
import { SCREEN_SIZE } from 'constants/screenSize'
// utils
import get from 'lodash/get'

const DrawerContent = styled.div<{ $width: string }>`
  width: ${({ $width }) => $width};
  height: 100%;
  display: flex;
  flex-direction: column;
`

export interface DrawerCustomProps extends Omit<DrawerProps, 'ModalProps'> {
  width?: string
  isOpen: boolean
  hideModal: () => void
  ModalProps?: DrawerProps['ModalProps'] & { disableBackdropClick?: boolean }
  contentWrapperStyles?: React.CSSProperties
}

const DrawerModal: React.FC<DrawerCustomProps> = ({
  width,
  isOpen,
  anchor = 'right',
  children,
  hideModal,
  ModalProps = {},
  contentWrapperStyles = {},
  ...rest
}) => {
  const isTablet = useMediaQuery(SCREEN_SIZE.TABLET)

  const { disableBackdropClick, ...modalProps } = ModalProps

  const onModalClose = (_event: React.MouseEvent, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (!disableBackdropClick && reason === 'backdropClick') {
      hideModal()
    }
  }

  React.useEffect(() => {
    return () => {
      hideModal()
    }
  }, [])

  return (
    <Drawer
      open={isOpen}
      anchor={anchor}
      ModalProps={{ ...modalProps, onClose: onModalClose }}
      PaperProps={{ square: true, ...get(rest, 'PaperProps', {}) }}
      {...rest}>
      <DrawerContent $width={isTablet ? '100vw' : width} style={contentWrapperStyles}>
        {children}
      </DrawerContent>
    </Drawer>
  )
}

export default DrawerModal
